/* eslint-disable react/no-unknown-property */
import React from 'react';
import Icon from '@ant-design/icons';

const svg = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.6">
      <path
        d="M10 9.33366L13.3333 6.00032L10 2.66699"
        stroke="#05034D"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.66602 13.3333V8.66667C2.66602 7.95942 2.94697 7.28115 3.44706 6.78105C3.94716 6.28095 4.62544 6 5.33268 6H13.3327"
        stroke="#05034D"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

const MoveIcon = (props) => <Icon component={svg} {...props} />;

export default MoveIcon;
